import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { Component } from "preact";
import html from "~/util/html.js";
import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./CopyBox.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./CopyBox.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {string} value
 */

/** @extends {Component<Props>} */
export default class CopyBox extends Component {
  #copied = signal(false);

  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #timeout;

  /** @override */
  componentWillUnmount() {
    clearTimeout(this.#timeout);
  }
  #copy = () => {
    navigator.clipboard.writeText(this.props.value);
    this.#setCopied();
  };
  #setCopied = () => {
    this.#copied.value = true;
    clearTimeout(this.#timeout);
    this.#timeout = setTimeout(() => {
      this.#copied.value = false;
    }, 3000);
  };
  render() {
    return __h("div", {
      "class": css.box
    }, __h("span", {
      "class": css.value,
      onCopy: this.#setCopied
    }, this.props.value), __h(Button, {
      size: "small",
      onClick: this.#copy
    }, __h(Icon, {
      name: "copy",
      size: 12
    }), this.#copied.value ? "Copied!" : "Copy"));
  }
}